<template lang="pug">
  div
    v-card-text
      .text-h6 Материалы урока
      .my-3
        v-btn(@click="openEditDialog(null, 'content_links')" small depressed rounded)
          v-icon(left) mdi-youtube
          | Добавить видео
        v-btn.ml-2.mt-2(@click="openEditDialog(null, 'content_files')" small depressed rounded)
          v-icon(left) mdi-attachment
          | Добавить файл
        v-btn.ml-2.mt-2(@click="openEditDialog(null, 'content_lecture')" small depressed rounded)
          v-icon(left) mdi-script-text-outline
          | Добавить лекцию
        v-btn.ml-auto.mt-2(@click="openEditDialog(null, 'content_telegram')"
          small depressed outlined rounded color="warning")
          v-icon(left) $telegram
          | Файл из телеграм хранилища
      .mb-5.mt-2
      v-list(v-if="attachments.length")
        v-list-item(v-for="(item, idx) in attachments" :key="idx")
          v-list-item-icon
            v-icon {{ item.icon }}
          v-list-item-content
            .text-body-2 {{ item.el.name }}
            v-list-item-subtitle {{ item.el.description }}
          v-list-item-action.flex-row
            v-btn(@click="openEditDialog(item.el, item.alias)" icon)
              v-icon(color="warning") mdi-pencil
            v-btn(
              :loading="loading.remove[item.el.id]"
              color="red"
              @click="remove(item.el, item.alias)" icon
            )
              span {{ loading.remove[item.id] }}
              v-icon(color="error") mdi-close
      p(v-else) Материалы урока не добавлены...

    add-video-dialog(
      v-model="showVideoDialog"
      @video:add="add($event, 'content_links')"
      @video:edit="edit($event, 'content_links')"
      :edit-data="editData"
      :lesson-instance="lessonInstance"
    )
    add-file-dialog(
      v-model="showFileDialog"
      @file:add="add($event, 'content_files')"
      @file:edit="edit($event, 'content_files')"
      :edit-data="editData"
      :lesson-instance="lessonInstance"
    )
    add-lecture-dialog(
      v-model="showLectureDialog"
      @lecture:add="add($event, 'content_lecture')"
      @lecture:edit="edit($event, 'content_lecture')"
      :edit-data="editData"
      :lesson-instance="lessonInstance"
    )
    add-telegram-dialog(
      v-model="showTelegramDialog"
      @telegram:add="add($event, 'content_telegram')"
      @telegram:edit="edit($event, 'content_telegram')"
      :edit-data="editData"
      :lesson-instance="lessonInstance"
    )
</template>

<script>
import AddVideoDialog from '@/modules/CourseManagement/components/AddVideoDialog.vue';
import AddFileDialog from '@/modules/CourseManagement/components/AddFileDialog.vue';
import AddStreamDialog from '@/modules/CourseManagement/components/AddStreamDialog.vue';
import AddLectureDialog from '@/modules/CourseManagement/components/AddLectureDialog.vue';
import AddTelegramDialog from '@/modules/CourseManagement/components/AddTelegramDialog.vue';

import { LESSON_TYPES } from '@/utils/constants';

export default {
  name: 'LessonCreateMaterialsForm',
  components: {
    AddLectureDialog, AddStreamDialog, AddFileDialog, AddVideoDialog, AddTelegramDialog,
  },
  props: {
    value: { type: Object, default: () => ({}) },
    lessonInstance: { type: Object, default: null },
  },
  data() {
    return {
      showStreamDialog: false,
      showTelegramDialog: false,
      showVideoDialog: false,
      showFileDialog: false,
      showLectureDialog: false,
      editData: null,

      loading: {
        remove: {},
      },

      LESSON_TYPES,
    };
  },
  computed: {
    // Merging attachments
    attachments() {
      const videoLinks = this.value.content_links.map(
        (i) => ({ el: i, icon: 'mdi-youtube', alias: 'content_links' }),
      );
      const materialsStudy = this.value.content_files.map(
        (i) => ({ el: i, icon: 'mdi-attachment', alias: 'content_files' }),
      );
      const lectures = this.value.content_lecture.map(
        (i) => ({ el: i, icon: 'mdi-script-text-outline', alias: 'content_lecture' }),
      );
      const telegram = this.value.content_telegram.map(
        (i) => ({ el: i, icon: '$telegram', alias: 'content_telegram' }),
      );
      return [...videoLinks, ...materialsStudy, ...lectures, ...telegram];
    },
  },
  methods: {
    add(item, alias) {
      this.update(alias, [...this.value[alias], item]);
    },
    edit(item, alias) {
      const idx = this.value[alias].indexOf(this.editData);
      const clonedArray = [...this.value[alias]];
      clonedArray[idx] = item;
      this.update(alias, clonedArray);
      this.editData = null;
    },
    async remove(item, alias) {
      if (this.lessonInstance) {
        this.$set(this.loading.remove, item.id, true);
        await this.removeHandler(item, alias);
        this.$set(this.loading.remove, item.id, false);
      } else {
        this.removeLocalItem(item, alias);
      }
    },
    async removeHandler(item, alias) {
      const REMOVE_METHODS = {
        content_files: this.$api.lessons.deleteFile,
        content_links: this.$api.lessons.deleteVideo,
        content_stream: this.$api.lessons.deleteStream,
        content_lecture: this.$api.lessons.deleteLecture,
        content_telegram: this.$api.telegram.deleteTelegramStorageLink,
      };
      return this.$rHandler(
        REMOVE_METHODS[alias](item.id),
        (resp) => {
          this.$toasted.success('Материал удален', { duration: 3000 });
          this.removeLocalItem(item, alias);
          return resp;
        },
      );
    },
    removeLocalItem(item, alias) {
      const updatedArray = this.value[alias]
        .filter((i) => i !== item);
      this.update(alias, updatedArray);
    },
    update(key, item) {
      this.$emit('input', {
        ...this.value,
        [key]: item,
      });
    },
    openEditDialog(item, alias) {
      this.editData = item;
      switch (alias) {
        case 'content_files': this.showFileDialog = true; break;
        case 'content_links': this.showVideoDialog = true; break;
        case 'content_stream': this.showStreamDialog = true; break;
        case 'content_lecture': this.showLectureDialog = true; break;
        case 'content_telegram': this.showTelegramDialog = true; break;
        default: break;
      }
    },
  },
};
</script>
